import React, { Component } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import $ from "jquery";
import Header from "../Layouts/Header";
import MenuSidebar from "../Layouts/MenuSidebar";
import { scrollToTopValidate, PageTitle } from "../Helpers/SettingHelper";
import { apiUrl } from "../Config/Config";
import axios from "axios";
import moment from "moment";

import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button,
} from "react-bootstrap";
const withRouter = (WrappedComponent) => (props) => {
  const params = useParams();
  const navigate = useNavigate();
  // etc... other react-router-dom v6 hooks

  return (
    <WrappedComponent
      {...props}
      params={params}
      navigate={navigate}
      // etc...
    />
  );
};
class View extends Component {
  constructor(props) {
    super(props);
    const userid =
      typeof props.params.ID === "undefined" ? "" : props.params.ID;

    this.state = {
      userid: userid,
      projectlistview: [],
      projectTaskListing: [],
      familtlistview: "",
    };
    
    var qs = require("qs");
    const postObject = {
      project_id: userid,
      admin_id: localStorage.getItem("admin_id"),
    };
   
   axios
    .post(apiUrl + "adminpanel/inv_project_view", qs.stringify(postObject))
    .then((res) => {
      if (res.data.status === "success") {
        const formdata = res.data.response[0];
        const taskListing = res.data.response[0].taskListing;
        
        if (formdata?.status === "A") {
          this.setState({
            selectedOption: { value: "active", label: "Active" },
          });
        } else {
          this.setState({
            selectedOption: { value: "inactive", label: "Inactive" },
          });
        }

        this.setState({ projectlistview: formdata, projectTaskListing: taskListing});
      }
    });

  }

  componentDidMount() {
    document.title = PageTitle("Project Details");
  }

  componentDidUpdate(prevProps, prevState) {}
  componentWillReceiveProps(Props) {}
  
  render() {
    const { projectlistview , projectTaskListing} = this.state;

    console.log(projectlistview, "projectlistview");
    console.log(projectTaskListing, "projectTaskListing");

    if (this.state.projectlistview.status == "A") {
      var status = "Active";
    } else {
      var status = "Inactive";
    }
    
    return (
      <div className="wrapper">
        <Header />
        <MenuSidebar currentpage="job" />

        <div className="content">
          <div className="content-wrapper">
            <div class="content-wrapper-before"></div>
            <div className="content-body">
              <div className="form-wrapper leaa-admin-head card">
                <div className="listing-header">
                  <div className="title">
                    <h3>Project Details</h3>
                  </div>

                  <div className="add_button">
                    <a className="" href="/project">
                      <i class="fa fa-arrow-left" aria-hidden="true"></i> Back
                    </a>
                  </div>
                </div>
                <div className="form-row">
                  <div className="details_left">
                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Job ID<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{projectlistview.constructionCode}</p>
                      </div>
                    </div>
                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Project<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{projectlistview.constructionName} ({projectlistview.constructionTypeName})</p>

                      </div>
                    </div>
                     <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Required Sq.Ft<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{projectlistview.constructionSqFt}</p>
                      </div>
                    </div>
                     <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Total Budget<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>${projectlistview.total_estimated_cost}</p>
                      </div>
                    </div>
                     <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Location<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{projectlistview.location}</p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* User Details */}
                <div className="title text-start">
                  <h3>User Details</h3>
                </div>
                <div className="form-row">
                  <div className="details_left">
                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Name<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{projectlistview.firstname}</p>
                      </div>
                    </div>
                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Mobile<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{projectlistview.user_mobile}</p>

                      </div>
                    </div>
                     <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Email<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{projectlistview.user_email}</p>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/*Contractor Details */}
                <div className="title text-start">
                  <h3>Contractor Details</h3>
                </div>
                <div className="form-row">
                  <div className="details_left">
                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Name<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{projectlistview.contractor_fname}</p>
                      </div>
                    </div>
                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Mobile<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{projectlistview.contractor_mobile}</p>

                      </div>
                    </div>
                     <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Email<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{projectlistview.contractor_email}</p>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/*Team Member Details */}
                <div className="title text-start">
                  <h3>Team Member Details</h3>
                </div>
                <div className="form-row">
                  <div className="details_left">
                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Name<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{projectlistview.subContractorfname}{" "}{projectlistview.subContractorlname || ""}</p>
                      </div>
                    </div>
                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Mobile<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{projectlistview.subcontractorMobile}</p>

                      </div>
                    </div>
                     <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Email<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{projectlistview.subcontractorEmail}</p>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/*Task Details */}
                <div className="title text-start">
                  <h3>Task Details</h3>
                </div>
                  <div className="car-listing-row">
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Task Name</th>
                          <th>Team Member name</th>
                          <th>ETA</th>
                          <th>Task Budget ($)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {projectTaskListing && projectTaskListing.length > 0 ? (
                          projectTaskListing.map((task, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{task.taskCategoryName}</td>
                              <td>
                               {task.taskMember}
                              </td>
                              <td>
                                {moment(task.startDate).format("MM/DD/YYYY")} to{" "}
                                {moment(task.endDate).format("MM/DD/YYYY")} ({task.eta}{" "}
                                days)
                              </td>
                              <td>${task.taskEstimatedCost}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No Task Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                 </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(View);
